export default __webpack_public_path__ + "static/media/Hubano-3.855064ef.png";